import React, { useEffect } from "react";
import { IoClose } from "react-icons/io5";
import CarrierPartnerPointManager from "./CarrierPartnerPointManager";

const CarrierPartnerPointModal = ({ open, onClose, onChanged }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-stone-900/50"
        aria-label="Close point name setup"
        onClick={onClose}
      />
      <div className="relative z-10 w-full max-w-xl max-h-[90vh] overflow-hidden rounded-2xl bg-white shadow-2xl border border-stone-200">
        <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-stone-200 bg-[#fcf8f5]">
          <div>
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-orange-600">
              Set-up
            </p>
            <h2 className="text-lg font-semibold text-stone-900">
              Point names
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="h-9 w-9 rounded-lg border border-stone-200 text-stone-600 hover:bg-stone-100 flex items-center justify-center"
            aria-label="Close"
          >
            <IoClose className="text-xl" />
          </button>
        </div>
        <div className="p-5 overflow-y-auto max-h-[calc(90vh-72px)]">
          <CarrierPartnerPointManager compact onChanged={onChanged} />
        </div>
      </div>
    </div>
  );
};

export default CarrierPartnerPointModal;
